import * as global from '../global';
import { Task } from './task';
export class Project {
	id: string;
	name: string;
	shortName: string;
	users: string[];
	managers: string[];
	tasks: Task[];
	createdTime: Date;
	updatedTime: Date;
	createdByUser: string;
	updatedByUser: string;
	constructor() {
		this.id = 'p_' + global.generateRandomString(-1);
		this.name = '';
		this.shortName = '';
		this.createdTime = new Date();
		this.updatedTime = new Date();
		this.tasks = [];//[new Task()];
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.modal/project.ts